import { BinItem } from 'Models/GetBinListModel';
import { useSelector } from 'react-redux';
import { CreditCardTransactionsState, creditCardTransactionsStore } from 'Stores/CreditCardTransactions';
import { formatCardBinNumber } from 'Utils';
import { useMemo } from 'react';

const useCreditCardType = (creditCardItem: any) => {
  const creditCardData: CreditCardTransactionsState = useSelector(creditCardTransactionsStore);
  const creditCardBinList: BinItem[] | undefined = creditCardData.creditCardBinList;

  const binObject = useMemo((): BinItem | undefined => {
    // Servis kartın BIN'ini hazır veriyor (`cardBin`, 6 ya da 8 hane). Maskeli
    // numarayı dilimlemek yerine onu kullanıyoruz: 8 haneli BIN'lerde maskeleme
    // deseni değişebiliyor ve dilimleme yanlış BIN üretebiliyor.
    const cardBinNumber = formatCardBinNumber(creditCardItem?.cardBin ?? creditCardItem?.maskedCardNumber);
    if (!cardBinNumber || !creditCardBinList || !Array.isArray(creditCardBinList)) return undefined;

    const cardBin = parseInt(cardBinNumber, 10);

    return creditCardBinList.find((bin) => {
      // BIN objesinin geçerli olduğunu ve gerekli alanların mevcut olduğunu kontrol et
      if (!bin || !bin.BinNumberMin || !bin.BinNumberMax) return false;

      const minBin = parseInt(bin.BinNumberMin, 10);
      const maxBin = parseInt(bin.BinNumberMax, 10);

      // NaN kontrolü
      if (isNaN(minBin) || isNaN(maxBin)) return false;

      return cardBin >= minBin && cardBin <= maxBin;
    });
  }, [creditCardItem?.cardBin, creditCardItem?.maskedCardNumber, creditCardBinList]);

  return {
    creditCardBrandUrl: binObject?.BankSchema || '',
    creditCardLogoUrl: binObject?.BankLink || '',
  };
};

export default useCreditCardType;
